import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatDialogRef} from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {ReportsSubscriptionsService} from '../../reports-subscriptions.service';


/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
    isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-report-subscription-dialog',
    templateUrl: './report-subscription-dialog.component.html',
    styleUrls: ['./report-subscription-dialog.component.scss'],
    entryComponents: [
        ConfirmComponent
    ],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
    ]
})
export class ReportSubscriptionDialogComponent implements OnInit {

    public local_title: string;
    public matcher = new FormErrorStateMatcher();
    public entityForm: FormGroup;   // store User Form
    public isEdit: boolean; // is insert or update
    public spinner: boolean = false;

    public categories:any[]=[]

    constructor (
        public matDialogRef: MatDialogRef<ReportSubscriptionDialogComponent>,
        private fb: FormBuilder,
        private _adapter: DateAdapter<any>,
        private _reportsSubscriptionsService:ReportsSubscriptionsService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {

    //  this.categories = this._reportsSubscriptionsService.loadCategories()
      this._reportsSubscriptionsService.loadCategories()
      .subscribe((result)=>{
        this.categories = []
  
        result.forEach((item)=>{
          this.categories.push({
            'id': item.id,
            'name': item.data().name
          })
        })

  
      })


     }


    ngOnInit () {
        this._adapter.setLocale('pt');
        this.local_title = "Inscrição"
        this.entityForm = this.createForm()
        this.setFormValues(this.data, this.entityForm)
    }

    setFormValues (data, form) {
        form.controls.id.setValue(data.id);
        form.controls.name.setValue(data.name);
        form.controls.email.setValue(data.email);
        form.controls.cpf.setValue(data.cpf);
        form.controls.nonMemberCategory_id.setValue(data.nonMemberCategory_id);
    }

    createForm () {
        let form: FormGroup = this.fb.group({
            id: new FormControl(''),
            name: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.required]),
            cpf: new FormControl('', [Validators.required]),
            nonMemberCategory_id: new FormControl('')
        });
        return form
    }



}
